import { I as Icon, _ as _taggedTemplateLiteral } from './Icon-980cc3c3.js';
import React from 'react';
import uniqueId from 'lodash/uniqueId';
import { svgWithValues } from 'nicollet-react-utilities';
import 'styled-components';

function _templateObject() {
  var data = _taggedTemplateLiteral(["<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FFF\" cx=\"12.037\" cy=\"12.037\" r=\"10.8\"/><path d=\"M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm1.47 4.136l1.06 1.061L9.727 12l4.803 4.803-1.06 1.06L7.606 12l5.864-5.864z\" fill=\"#333\" fill-rule=\"nonzero\"/></g></svg>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var svgData = svgWithValues(_templateObject());
var svgMetadata = {
  "width": 24,
  "height": 24,
  "id": "NavigationArrowLeftCircle",
  "monochrome": false,
  "grayscale": true,
  "fullColor": false,
  "fills": ["#000000", "#ffffff", "#333333"],
  "nameComponents": {
    "name": "ArrowLeftCircle",
    "category": "Navigation",
    "variant": null
  }
};

var IconNavigationArrowLeftCircle = function IconNavigationArrowLeftCircle(props) {
  var idPrefix = props.id || uniqueId('nds-Icon');
  var finalSVGData = svgData({
    idPrefix: idPrefix
  });
  return React.createElement(Icon, Object.assign({}, props, {
    svgData: finalSVGData,
    svgMetadata: svgMetadata
  }));
};

IconNavigationArrowLeftCircle.metadata = svgMetadata;
IconNavigationArrowLeftCircle.displayName = 'IconNavigationArrowLeftCircle';

export { IconNavigationArrowLeftCircle };
